export default __webpack_public_path__ + "static/media/CourseSpot.87837bd2.png";